<template>
    <!-- Panel de configuración de notificaciones -->
    <div class="notification-config-panel">
        <div class="config-header">
            <h6>Configuración de Notificaciones</h6>
            <div class="toggle-container">
                <label class="toggle-label">
                    <input 
                        type="checkbox"
                        :checked="applyNotification"
                        @change="handleToggleNotifications"
                    >
                    <span class="toggle-slider"></span>
                    <span class="toggle-text">Activar notificaciones</span>
                </label>
            </div>
        </div>

        <!-- Selector de frecuencias (solo si las notificaciones están activadas) -->
        <div v-if="applyNotification" class="frequency-selector">
            <label class="selector-label">Frecuencias de notificación:</label>
            <div class="multiselect-container">
                <el-select 
                    v-model="localFrequencies" 
                    multiple 
                    placeholder="Selecciona frecuencias"
                    class="frequency-multiselect"
                >
                    <el-option 
                        v-for="frequency in frequencyDefinitions" 
                        :key="frequency.id"
                        :label="frequency.name + ' (' + frequency.days + ' días)'" 
                        :value="frequency.id"
                    />
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationConfigPanel',
    props: {
        applyNotification: {
            type: Boolean,
            default: false,
        },
        selectedFrequencies: {
            type: Array,
            default: () => [],
        },
        frequencyDefinitions: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        localFrequencies: {
            get() {
                return this.selectedFrequencies;
            },
            set(value) {
                this.$emit('update-frequencies', value);
            }
        }
    },
    methods: {
        handleToggleNotifications(event) {
            this.$emit('toggle-notifications', event.target.checked);
        }
    },
};
</script>

<style scoped>
.notification-config-panel {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
}

.config-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.config-header h6 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
}

.toggle-container {
    display: flex;
    align-items: center;
}

.toggle-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.toggle-label input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    background-color: #ccc;
    border-radius: 24px;
    transition: background-color 0.3s;
    margin-right: 8px;
}

.toggle-slider::before {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s;
}

.toggle-label input[type="checkbox"]:checked + .toggle-slider {
    background-color: #3b82f6;
}

.toggle-label input[type="checkbox"]:checked + .toggle-slider::before {
    transform: translateX(20px);
}

.toggle-text {
    font-size: 0.875rem;
    color: #374151;
}

.frequency-selector {
    margin-top: 12px;
}

.selector-label {
    display: block;
    font-size: 0.85rem;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 8px;
}

.multiselect-container {
    width: 100%;
}

.frequency-multiselect {
    width: 100%;
}
</style>
